// extracted by mini-css-extract-plugin
export var header = "_bg-0";